import React, { useEffect, useState } from 'react';
import { Text, TextVariant } from '@naf/text';
import { Loader } from '@naf-simba/building-blocks-loaders';
import { Input } from '@naf/input';
import { ProductType, useProductChangeCalculator } from '@hooks/useProductChangeCalculator';
import { useSessionStorage } from '@hooks/useSessionStorage';
import { OilChangeCalculations } from '@appTypes/oilChangeCalculationTypes';
import useSelector from '@redux/typedHooks';
import { normalizeLicensePlate } from '@utils/normalizeLicensePlate';
import { OilChangeLookupError, OilChangeResult } from './OilChangeResult';
import * as S from './OilChangeCalculator.styles';

export const OilChangeCalculatorBlock = () => {
  const [centerId] = useSessionStorage('centerId', undefined);
  const [licensePlateNumber, setLicensePlateNumber] = useState<string>('');
  const [calculationResult, setCalculationResult] = useState<OilChangeCalculations | undefined>();
  const { calculate, calculation, isLoading, error } = useProductChangeCalculator({
    productType: ProductType.OILCHANGE,
    licensePlateNumber,
    centerId: centerId as string | undefined,
  });

  const isMember = useSelector((state) => state?.myMembership?.customerInformation?.data?.membership?.isValid ?? false);

  // Held locally so the last result stays up while the next lookup runs.
  useEffect(() => {
    setCalculationResult(calculation as OilChangeCalculations);
  }, [calculation]);

  return (
    <S.OilChange>
      {calculationResult?.oilChange?.isCampaign && <S.StyledTag color="secondary" shade="light" text="Kampanje" />}
      <Text variant={TextVariant.Header2}>Se hvor mye oljeskift på din bil koster</Text>
      <Text variant={TextVariant.ArticleTextLarge}>
        Legg inn registeringsnummer for å beregne hvor mye oljeskiftet koster for din bil.
      </Text>
      <S.Search>
        <Input
          placeholder="Registreringsnummer"
          id="registrationNumber"
          type="text"
          onChange={(number: string) => {
            setLicensePlateNumber(normalizeLicensePlate(number));
          }}
          onKeyUp={(e: KeyboardEvent) => {
            if (e.key === 'Enter') calculate();
          }}
        />
        <S.StyledButton type="button" color="secondary" onClick={() => calculate()}>
          Beregn pris
        </S.StyledButton>
      </S.Search>
      {isLoading && (
        <S.SpinnerWrapper>
          <Loader />
        </S.SpinnerWrapper>
      )}
      {error && !isLoading && <OilChangeLookupError />}
      {!error && !isLoading && calculationResult && (
        <OilChangeResult calculation={calculationResult} isMember={isMember} />
      )}
    </S.OilChange>
  );
};
